import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private _authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this._authService.getCurrentUser();
    const isLoggedIn = currentUser && currentUser?.jwt;
    const isApiUrl = request.url.startsWith(environment.base_url);
    const isRefreshUrl = request.url.includes('/login/refresh');
    const isLogoutUrl = request.url.includes('/logout');
    const token = isRefreshUrl ? currentUser?.jwt_refresh : currentUser?.jwt;
    const loginUrl = environment.base_url + '/login';

    if (isLoggedIn && isApiUrl) {
      request = this.addTokenToRequest(request, token);
    }
    return next.handle(request).pipe(
      catchError((error: any) => {
        if(error.status === 422 && error?.error?.msg === 'Signature verification failed'){
          this._authService.logout();
          location.reload();
        }
        if (error instanceof HttpErrorResponse && error.status === 401 && error.url != loginUrl && !isRefreshUrl && !isLogoutUrl) {
          if (!this.refreshTokenInProgress) {
            this.refreshTokenInProgress = true;
            this.refreshTokenSubject.next(null);

            return this._authService.refreshToken().pipe(
              switchMap((jwt: string) => {
                this.refreshTokenInProgress = false;
                this.refreshTokenSubject.next(jwt);
                return next.handle(this.addTokenToRequest(request, jwt));
              }),
              catchError((refreshError) => {
                this.refreshTokenInProgress = false;
                this._authService.logout();
                location.reload();
                return throwError(refreshError);
              })
            );
          } else {
            return this.refreshTokenSubject.pipe(
              filter((jwt) => jwt !== null),
              take(1),
              switchMap((jwt) => next.handle(this.addTokenToRequest(request, jwt)))
            );
          }
        } else {
          return throwError(error);
        }
      })
    );
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

}
